<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-5" *ngIf="serverError === null">
  <h2 class="mb-3">
    Org-Wide Membership Policies
    <span *ngIf="loadingOrgConfig" class="text-muted"> - Loading...</span>
  </h2>

  <p class="lead">
    The following policies apply to all memberships in your organization.
  </p>

  <ng-container *ngIf="!loadingOrgConfig">
    <form (submit)="handleSave()" *ngIf="orgConfig">

      <div class="form-group">
        <label for="failedMembershipCancellationPeriodDaysInput">
          Failed payment membership automatic cancellation period (days, optional)
        </label>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-5">
            <input id="failedMembershipCancellationPeriodDaysInput" type="number"
                   name="failed_membership_cancellation_period_days"
                   min="20" step="1"
                   class="form-control"
                   [(ngModel)]="orgConfig.failed_membership_cancellation_period_days">
          </div>
        </div>
        <small class="form-text text-muted">
          If provided, this is the number of days after which a membership with an unresolved failed payment will be automatically cancelled. If left blank, memberships will be left in the "Payment Failed" state indefinitely.
        </small>
        <small class="form-text text-muted">
          Please note that when a membership with a failed payment is fixed, multiple charges may be made if the membership has been in the "Failed Payment" state for more than its payment interval. For example, if a monthly membership is fixed after three months in the "Failed Payment" state, three payments will be automatically made in order to bring the membership up to date.
        </small>
        <div class="form-text text-danger">{{ errors.failed_membership_cancellation_period_days }}</div>
      </div>

      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 name="send_recurring_membership_payment_confirmation_emails"
                 id="sendRecurringMembershipPaymentConfirmationEmailsInput"
                 [(ngModel)]="orgConfig.send_recurring_membership_payment_confirmation_emails">
          <label class="form-check-label" for="sendRecurringMembershipPaymentConfirmationEmailsInput">
            Send recurring membership payment confirmation emails
          </label>
          <div class="form-text text-danger">{{ errors.send_recurring_membership_payment_confirmation_emails }}</div>
        </div>
        <small class="form-text text-muted">
          Disable this option to prevent confirmation emails from being sent for recurring membership payments. Note that confirmation emails will always be sent when a membership is first purchased, and that this setting may be ignored where regulations require such emails to be sent.
        </small>
      </div>

      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 name="send_membership_max_freeze_soon_emails"
                 id="sendMembershipMaxFreezeSoonEmailsInput"
                 [(ngModel)]="orgConfig.send_membership_max_freeze_soon_emails">
          <label class="form-check-label" for="sendMembershipMaxFreezeSoonEmailsInput">
            Send notification emails before membership maximum freeze period is reached
          </label>
          <div class="form-text text-danger">{{ errors.send_membership_max_freeze_soon_emails }}</div>
        </div>
        <small class="form-text text-muted">
          If enabled, emails will be sent to membership owners 5 days before the membership will be automatically unfrozen or cancelled
          due to its maximum freeze period being reached. This is not relevant for membership types with no configured maximum freeze period.
        </small>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingSave">
        Loading...
      </div>

      <div class="alert alert-success" role="alert" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <!-- Place save button first so that the enter key press activates it -->
      <div class="float-right">
        <button type="submit" class="btn btn-primary"
                [disabled]="loadingSave" [class.disabled]="loadingSave">
          {{ loadingSave ? 'Loading...' : 'Save' }}
        </button>
      </div>
      <a [routerLink]="'/memberships-and-passes'"
         class="btn btn-secondary"
         [class.disabled]="loadingSave">
        Back
      </a>

    </form>
  </ng-container>
</div>
